'use strict';

// http://262.ecma-international.org/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/2024/ToBoolean.js
// module id = 667
// module chunks = 0